import React from 'react'
import {
    Card, CardImg, CardText, CardBody, UncontrolledCollapse,
    Button, Badge,
    Container
} from 'reactstrap';

import ListasPrecioInicio from '../../../../public/img/Help/ListasPrecioInicio.png';
import ListasPrecioAdjunto from '../../../../public/img/Help/ListasPrecioAdjunto.png';
import CondicionPagoInicio from '../../../../public/img/Help/CondicionPagoInicio.png';
import CondicionPagoEditar from '../../../../public/img/Help/CondicionPagoEditar.png';
import NovedadesInicio from '../../../../public/img/Help/NovedadesInicio.png';
import NovedadesCrear from '../../../../public/img/Help/NovedadesCrear.png';
import PedidosInicio from '../../../../public/img/Help/PedidosInicio.png';
import PedidosDetalle from '../../../../public/img/Help/PedidosDetalle.png';

const Generales = () => {
    return (
        <Container fluid className="rounded contenedor-scrolleable">
            <header>
                <h2 className="text-center">Generales</h2>
            </header>
            <div>
                <Button color="primary" id="Pedidos" style={{ marginBottom: '1rem' }}>
                    Ver mis Pedidos
                </Button>
                <UncontrolledCollapse toggler="#Pedidos">
                    <Card>
                        <CardImg top width="100%" src={PedidosInicio} className="img-fluid" alt="Pedidos" title="Pedidos Inicio" />
                        <CardBody>
                            <CardText>
                            En la sección de Pedidos sé podra consultar por los pedidos que han sido creados ya sea por un vendedor o a través de sitio tienda.<br/>
                            Existe una lógica en lo referente a los estados de los pedidos:<br/>
                                <ul>
                                    <li><Badge className="rounded" color="danger">Pendiente</Badge>: El pedido fue creado pero no atendido.
                                        <ul>
                                            <li>Si se descargan los pedidos al SIGE de forma automática como notas de pedido, entonces eventualmente avanzara a un estado <Badge className="rounded" color="danger">Pendiente de Facturación</Badge>.</li>
                                            <li>En caso contrario, queda en responsabilidad de un usuario el cambiarle el estado.</li>
                                        </ul>
                                    </li>
                                    <li><Badge className="rounded" color="primary">Cancelado</Badge>: El pedido fue cancelado.</li>
                                    <li><Badge className="rounded" color="success">Confirmado</Badge>: El pedido fue Confirmado.</li>
                                    <li><Badge className="rounded" color="success">Facturado</Badge>: El pedido fue procesado en el SIGE.</li>
                                </ul>
                            </CardText>
                        </CardBody>
                        <CardImg top src={PedidosDetalle} className="img-modal-content" alt="Pedidos Detalle" title="Pedidos Detalle" />
                    </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="CPInicio" style={{ marginBottom: '1rem' }}>
                    Cambiando el nombre a la Condición de Pago
                </Button>
                <br />
                <Button color="primary" id="LPInicio" style={{ marginBottom: '1rem' }}>
                    Adjuntando un fichero a una lista de precios
                </Button>
                <UncontrolledCollapse toggler="#LPInicio">
                    <Card>
                        <CardImg top width="100%" src={ListasPrecioInicio} className="img-fluid" alt="LPInicio" title="Listas de Precios Inicio" />
                        <CardBody>
                            <CardText>Es posible adjuntar un fichero a una lista de precios a fin de que clientes que tengan asignada dicha lista de precios como principal puedan descargarlos.</CardText>
                        </CardBody>
                        <CardImg top src={ListasPrecioAdjunto} className="img-modal-content" alt="Adjuntar Fichero" title="Adjuntar Fichero" />
                    </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="CPInicio" style={{ marginBottom: '1rem' }}>
                    Cambiando el nombre a la Condición de Pago
                </Button>
                <UncontrolledCollapse toggler="#CPInicio">
                    <Card>
                        <CardImg top width="100%" src={CondicionPagoInicio} className="img-fluid" alt="Condiciones de Pago Inicio" title="Condiciones de Pago Inicio" />
                        <CardBody>
                            <CardText>Si diera la necesidad de querer cambiar el nombre de la condición de pago por otro, la condición de pago tiene asociado 2 nombres, el definido en SIGE y otro que figura en web.</CardText>
                        </CardBody>
                        <CardImg top src={CondicionPagoEditar} className="img-modal-content" alt="Condiciones de Pago" title="Condiciones de Pago" />
                    </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="NInicio" style={{ marginBottom: '1rem' }}>
                    Creando Novedades
                </Button>
                <UncontrolledCollapse toggler="#NInicio">
                    <Card>
                        <CardImg top width="100%" src={NovedadesInicio} className="img-fluid" alt="Novedades Inicio" title="Novedades Inicio" />
                        <CardBody>
                            <CardText>Es posible crear novedades y ordenarlas según la fecha de última modificación.</CardText>
                        </CardBody>
                        <CardImg top src={NovedadesCrear} className="img-modal-content" alt="Crear Novedad" title="Crear Novedad" />
                    </Card>
                </UncontrolledCollapse>
                <br />
            </div>
        </Container>
    )
}
export default Generales;


// WEBPACK FOOTER //
// ./src/views/Ayuda/Paneles/Generales.js